import React, { Component } from 'react';
import { Switch, Route, Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Container, Alert } from 'react-bootstrap';

// Components
import Dashboard from './components/Dashboard';
import Upload from './components/Upload';
import Jobs from './components/Jobs';
import JobDetail from './components/JobDetail';
import Models from './components/Models';
import About from './components/About';
import Help from './components/Help';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }

  showAlert = (message, variant = 'success') => {
    this.setState({ alert: { message, variant } });
    setTimeout(() => {
      this.setState({ alert: null });
    }, 5000);
  };

  render() {
    const { alert } = this.state;

    return (
      <div className="App">
        <Navbar bg="primary" variant="dark" expand="lg" sticky="top">
          <Container>
            <Navbar.Brand as={Link} to="/">
              🧭 Odyssey23
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="main-nav" />
            <Navbar.Collapse id="main-nav">
              <Nav className="mr-auto">
                <Nav.Link as={NavLink} to="/" exact>
                  Dashboard
                </Nav.Link>
                <Nav.Link as={NavLink} to="/upload">
                  Upload
                </Nav.Link>
                <Nav.Link as={NavLink} to="/jobs">
                  Jobs
                </Nav.Link>
                <Nav.Link as={NavLink} to="/models">
                  Models
                </Nav.Link>
              </Nav>
              <Nav>
                <Nav.Link as={NavLink} to="/help">
                  Help
                </Nav.Link>
                <Nav.Link as={NavLink} to="/about">
                  About
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {alert && (
          <div className="alert-container">
            <Alert variant={alert.variant} dismissible onClose={() => this.setState({ alert: null })}>
              {alert.message}
            </Alert>
          </div>
        )}

        <Container className="mt-4">
          <Switch>
            <Route exact path="/">
              <Dashboard showAlert={this.showAlert} />
            </Route>
            <Route path="/upload">
              <Upload showAlert={this.showAlert} />
            </Route>
            <Route exact path="/jobs">
              <Jobs showAlert={this.showAlert} />
            </Route>
            <Route path="/jobs/:id">
              <JobDetail showAlert={this.showAlert} />
            </Route>
            <Route path="/models">
              <Models showAlert={this.showAlert} />
            </Route>
            <Route path="/help">
              <Help />
            </Route>
            <Route path="/about">
              <About />
            </Route>
          </Switch>
        </Container>

        <footer className="footer">
          <Container>
            <span>Odyssey23 - ML-Powered Data Cleaning Platform</span>
            <span className="float-right">
              <Link to="/help" className="text-light mr-3">Help</Link>
              <Link to="/about" className="text-light">About</Link>
            </span>
          </Container>
        </footer>
      </div>
    );
  }
}

export default App;